<template>
  <view class="goods-action goods-action--safe">
    <view class="goods-action-icon">
      <u-icon name="chat" label-pos="bottom" label="客服" size="50"></u-icon>
    </view>
    <view class="goods-action-icon" @click="goToCart">
      <u-badge type="error" :count="cartGoodsNum" :offset="[0, 15]"></u-badge>
      <u-icon name="bag" label-pos="bottom" label="购物车" size="50"></u-icon>
    </view>
    <button class="goods-action-button goods-action-button-first" @click="addToCart">加入购物车</button>
    <button class="goods-action-button goods-action-button-last" @click="buyNow">立即购买</button>
  </view>
</template>

<script>
export default {
  name: 'GoodsAction',
  props: {
    safeAreaInsetBottom: {
      type: Boolean,
      default: true,
    },
    cartGoodsNum: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    addToCart() {
      this.$emit('addToCart');
    },
    buyNow() {
      this.$emit('buyNow');
    },
    goToCart() {
      this.$emit('goToCart');
    },
  },
};
</script>

<style scoped lang="scss">
.goods-action {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  box-sizing: initial;
  height: 50px;
  background-color: #fff;
}
.goods-action--safe {
  padding-bottom: env(safe-area-inset-bottom);
}
.goods-action-icon {
  position: relative;
  //border: 1px solid #2c405a;
  width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  &:first-child {
    margin-left: 15px;
  }
}
.goods-action-button {
  height: 40px;
  line-height: 40px;
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  margin: 0;
  flex: 1;
  &:after {
    border: none;
  }
}
.goods-action-button-first {
  background: linear-gradient(90deg, #ffd01e, #ff8917);
  border-radius: 20px 0 0 20px;
  margin-left: 5px;
}
.goods-action-button-last {
  background: linear-gradient(to right, #ff6034, #ee0a24);
  border-radius: 0 20px 20px 0;
  margin-right: 5px;
}
</style>
